import SelectReviewLevel from 'corp/components/UI/SelectReviewLevel';
import SelectWorkerSource from 'corp/components/UI/SelectWorkerSource';
import SelectCountry from 'corp/components/UI/SelectCountry';
import SelectTierStatus from 'corp/components/UI/SelectTierStatus';
import TagSelector from 'corp/components/UI/TagSelector';
import SelectCommunity from 'corp/components/UI/SelectCommunity';
import { ICommunityOption } from '@scale/shared/types/Community';

const OPTIONS_WIDTH = '300px';

const SlackChannelOptionsEditor = (props: $FIXME) => {
  return (
    <>
      <div className="options-container">
        <div className="option-container">
          <label>Communities: </label>
          <SelectCommunity
            fullWidth
            multi={true}
            value={props.channel.communities}
            communityOptions={props?.communityOptions ?? []}
            onChange={(communities: ICommunityOption[]) =>
              props.editPermissionCommunities(communities)
            }
            style={{ width: OPTIONS_WIDTH }}
            communities={props.channel.communities}
          />
        </div>
        <div className="option-container">
          <label>Countries: </label>
          <SelectCountry
            fullWidth
            multi={true}
            value={props.channel.countries}
            onChange={(countries: $FIXME[]) => props.editPermissionCountries(countries)}
            style={{ width: OPTIONS_WIDTH }}
          />
        </div>
        <div className="option-container">
          <label>Review Levels: </label>
          <SelectReviewLevel
            value={props.channel.reviewLevels}
            includeAnyPermission={true}
            includeL11={true}
            multi={true}
            onChange={(reviewLevels: $FIXME[]) => props.editPermissionReviewLevel(reviewLevels)}
            style={{ width: OPTIONS_WIDTH }}
          />
        </div>
        <div className="option-container">
          <label>Worker Sources: </label>
          <SelectWorkerSource
            fullWidth
            multi={true}
            includeNoWorkerSource={true}
            value={props.channel.workerSources}
            onChange={(workerSources: $FIXME[]) => props.editPermissionWorkerSources(workerSources)}
            style={{ width: OPTIONS_WIDTH }}
          />
        </div>
        <div className="option-container">
          <label>Tier Statuses: </label>
          <SelectTierStatus
            fullWidth
            multi={true}
            includeNoWorkerSource={true}
            value={props.channel.tierStatuses}
            onChange={(tierStatuses: $FIXME[]) => props.editPermissionTierStatuses(tierStatuses)}
            style={{ width: OPTIONS_WIDTH }}
          />
        </div>
        <div className="option-container">
          <label>Tags: </label>
          <div style={{ width: '450px' }}>
            <TagSelector
              tags={props.channel.tags ?? []}
              onTagsChanged={newTags => props.editPermissionTags(newTags)}
            />
          </div>
        </div>

        <div className="option-container">
          <label>Require all Tags: </label>
          <div style={{ width: '450px' }}>
            <label>
              <input
                type="checkbox"
                checked={!!props.channel.requireAllTags}
                onChange={() => {
                  props.editPermissionRequireAllTags(!props.channel.requireAllTags);
                }}
              />
            </label>
          </div>
        </div>
      </div>
      <style jsx>{`
        .options-container {
          padding-top: 10px;
        }

        .option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          padding: 10px 0px 12px 0px;
          gap: 4px;
        }
      `}</style>
    </>
  );
};

export default SlackChannelOptionsEditor;
